import { render, staticRenderFns } from "./CreateRemittanceMLX.vue?vue&type=template&id=31ab6666&"
import script from "./CreateRemittanceMLX.vue?vue&type=script&lang=ts&"
export * from "./CreateRemittanceMLX.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports